import {createSelector} from 'reselect'
import {State} from 'lib/store'
import {DictionariesState} from './reducer'

const selectFeature = (state: State): DictionariesState => state.dictionaries

export const getType = createSelector(selectFeature, (dictionaries) => dictionaries.type)
